/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-04 09:45:53
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-02 13:51:54
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../../../app/store'
import { sendAsync } from '../../../../app/applicationSlice'
import * as DT from '../../../../services/outPatientRegistrationReport'

// 列表
export const getOutPatientRegistrationReportList = createAsyncThunk<
  void,
  DT.OutPatientRegistrationReportPrams,
  RootThunkApi<void>
>('clinic/getOutPatientRegistrationReportList', async (params, api) => {
  return sendAsync(DT.outPatientRegistrationReportList(params), api)
})

// 导出
export const getOutPatientRegistrationReportExport = createAsyncThunk<
  void,
  DT.OutPatientRegistrationReportPrams,
  RootThunkApi
>('stand/getUseDetailExport', async (params, api) => {
  return sendAsync(DT.getExportFn(params), api)
})